import { instance } from '@/libs/api/instance.js'

/**
 * Get websocket token
 *
 *  @return {Promise<AxiosResponse<any>>}
 */

export const getWsToken = async () => {
  return instance.get('/v3/auth/web-socket')
}
